package com.taocent.simple.compose.component.richtext.core.internal.serialization

/**
 * HTML 特殊字符 escape / unescape 工具。
 *
 * escape 范围:`&` `<` `>` `"` `'`(五个 HTML 核心字符);以及非 ASCII 不可打印字符
 * (保留换行 / 制表 / 普通空格)。与 [HtmlToAnnotatedString.decodeEntity] 反向配合。
 *
 * 用法:
 * - [AnnotatedStringToHtml] 序列化时,对所有 attribute value / text node 调用
 *   [escape] 再拼接。
 * - [HtmlToAnnotatedString] 解析时,内部 `decodeEntity` 已处理 `&xxx;`,不依赖
 *   这里的 [unescape](也不需要 ——
 *   `decodeEntity` 覆盖了 named/decimal/hex numeric entity + 常见符号)。
 *
 * 设计取舍:
 * - 不 escape 单引号 `'`?为 `&apos;`?实际生产里**会** escape,避免属性值用
 *   单引号包裹时出现歧义(`<a href='...'>`)。
 * - 留 `&apos;` 数值 entity 形式:大部分浏览器对 `&apos;` 兼容性 OK,IE 8 之前不识别
 *   但本项目目标平台是现代浏览器 / Compose Multiplatform,无问题。
 */
internal object RichTextHtmlEscape {

    fun escape(text: String): String {
        val sb = StringBuilder(text.length + 16)
        for (c in text) {
            when (c) {
                '&' -> sb.append("&amp;")
                '<' -> sb.append("&lt;")
                '>' -> sb.append("&gt;")
                '"' -> sb.append("&quot;")
                '\'' -> sb.append("&apos;")
                else -> sb.append(c)
            }
        }
        return sb.toString()
    }
}
